/* eslint-disable no-param-reassign */
import { produce } from 'immer';

import { FETCH_EXTENSIONS_SUCCESS } from 'constants/ActionTypes';

/**
 * @typedef {{
 *   data: import("modules/global/typing/enums/extensions.enum").ExtensionEnum[],
 * }} ExtensionReducer
 */

/** @type {ExtensionReducer} */
const initialState = {
  data: [],
};

const reducer = produce(
  /** @param {ExtensionReducer} draft  */
  (draft, action) => {
    switch (action.type) {
      case FETCH_EXTENSIONS_SUCCESS:
        draft.data = [...action.payload].sort((extensionA, extensionB) => extensionA.localeCompare(extensionB));
        break;
      default:
    }
    return draft;
  },
  initialState
);

export default reducer;
